<template>
  <a-modal title="项目选择" :visible="itemSelectionShow" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" :getContainer="getContainer" :mask="false">
    <div>
      <a-form-model>
        <a-form-model-item label="用户选择" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <a-select show-search placeholder="请选择项目" option-filter-prop="children" style="width: 300px"
            :filter-option="filterOption" @change="handleChangeUser" v-model="userKey"
            :getPopupContainer="triggerNode => triggerNode.parentNode">
            <template v-for="(item, index) in userSelection" @key="index">
              <a-select-option :value="item.phone">
                {{ item.userName }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="项目选择" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <a-select show-search placeholder="请选择项目" option-filter-prop="children" style="width: 300px"
            :filter-option="filterOption" @focus="handleFocus" @blur="handleBlur" @change="handleChange"
            v-model="itemId" :getPopupContainer="triggerNode => triggerNode.parentNode">
            <template v-for="(item, index) in itemSelection" @key="index">
              <a-select-option :value="item.id">
                {{ item.projectName }}
              </a-select-option>
            </template>
          </a-select>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: "ItemSelectionModule",
  props: {
    itemSelectionShow: {
      type: Boolean,
      default: () => false,
    },
  },
  data () {
    return {
      itemId: undefined,
      userKey: undefined,
      itemSelection: [],
      userSelection: [],
      queryUserUrl: '/gis-manager/user/deploy/user/list/1',
      itemSelectionUrl: '/gis-manager/diagramming/project/list?isPicture=1',
      confirmLoading: false,
    };
  },
  watch: {
    itemSelectionShow (newVal) {
      if (newVal) {
        this.queryUserApi();
      }
    }
  },
  methods: {
    queryUserApi () {
      this.userKey = undefined;
      this.itemId = undefined;
      this.itemSelection = [];
      this.$http.get(this.queryUserUrl).then(res => {
        this.userSelection = res.data

      })
    },
    getContainer () {
      return document.getElementById("pipeline-mapping");
    },
    handleChangeUser () {
      this.itemId = undefined;
      this.getitemSelection();
    },
    getitemSelection () {
      this.$http.get(this.itemSelectionUrl + '&phone=' + this.userKey).then(res => {
        this.itemSelection = res.data;
      });
    },
    handleOk () {
      // 处理确认按钮点击
      this.$emit('toggle-to-parent', this.itemId);
    },
    handleCancel () {
      this.$emit("update:itemSelectionShow", false);
    },
    handleChange (value) {
      // this.itemId = value
      console.log(`selected ${value}`);
    },
    handleBlur () {
      console.log('blur');
    },
    handleFocus () {
      console.log('focus');
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-layout-sider-children {
  background-color: white;
}

/deep/ .ant-select-dropdown {
  z-index: 9999;
  /* 确保 z-index 足够高 */
}

// 先全局把它原本的样式干掉

/deep/ .ant-modal-mask,
/deep/ .ant-modal-wrap {
  position: absolute !important;
}
</style>